import type { FaireProductEntity } from "../../entity_types/product";

export const p_cttesmzftz: FaireProductEntity = {
  token: "p_cttesmzftz",
  type: "product",
  name: "Gourmetnut, Power Up 14, HIGH ENERGY, 6/14oz(K)",
  brandToken: "b_22qxjttyk7",
  brandName: "NuEats",
  imageUrl:
    "https://cdn.faire.com/fastly/d568e577179d2e65e50ad7ad235450ef6eee5eeb0ac9ef50496105c645b04b41.png",
  galleryImageUrls: [],
  priceDollars: 9.01,
  description:
    "More Than Your Average Trail Mix - Our carefully selected blend of pecans, cranberries, walnuts, raisins, blueberries, and dark chocolate create protein snacks with a taste that is out of this world. Wholesome, simple ingredients make this snack mix the perfect way to indulge without the guilt! We use 52% Cacao rich dark chocolate that melts in your mouth! Dark chocolate is a powerful source of antioxidants & is a much better alternative than milk chocolate, which is higher in sugar & calories.",
  tags: [],
  msrpDollars: 18.01,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:56:39.503Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
